import { getBucketId } from "@/common/feature-toggling";

import {
	readSavedWords,
	readDictionary,
	getDefaultDictionariesByPage,
} from "@/common/functions";

export function mounted() {
	this.detectAdBlocker();
}

export function created() {
	if (window.__TEST__ !== true) {
		this.checkLastVisited();

		// load query filters & dictionary
		const defaultDictionary = getDefaultDictionariesByPage(
			this.$store.state.navigation.current
		);
		const dictionary = readDictionary(defaultDictionary);

		const queryFilters = {
			dictionary,
		};
		this.$store.commit("loadFilters", queryFilters);
	}

	this.onWindowResize(); // Set the current window size.
	if (typeof window.__PRERENDER_INJECTED === "undefined") {
		window.addEventListener("resize", this.onWindowResize);
		this.onWindowResize();

		window.addEventListener("scroll", this.onWindowScroll);
		this.onWindowScroll();
	}

	this.$store.commit("setLoadingSavedWords", true);
	this.$store.commit("loadSavedWords", readSavedWords());
	this.$store.commit("setLoadingSavedWords", false);

	const bucketId = getBucketId();
	const dimensionStr = `${
		this.features?.toggles ? `${bucketId}:` : ""
	}${this.features?.toggles.join(",")}`;

	if (this.$ga) {
		this.$ga.set("dimension4", dimensionStr);
		this.$ga.set("metric1", bucketId);
	}

	if (isFeatureEnabled("InvertedUI")) {
		document.getElementsByTagName("BODY")[0].classList.add("inverted-ui");
	}

	// Get the user's location.
	this.$store.dispatch("getLocation");
}

export function destroyed() {
	if (typeof window.__PRERENDER_INJECTED === "undefined") {
		window.removeEventListener("resize", this.onWindowResize);
		window.removeEventListener("scroll", this.onWindowScroll);
	}
}
